<template>
  <v-image :config="{ ...configImage, image: image }" ref="imgRef" />
</template>

<script>
import Konva from 'konva'
import { get, cloneDeep, omit } from 'lodash'
import { mapGetters, mapMutations } from 'vuex'
import { getImageURL, rotation as getRotation } from '@/helper/helper'

export default {
  name: 'ImagePreview',
  // Chỉ có khi nằm trong stage chụp ẩn của LoadArThree.
  inject: {
    previewImageTracker: { default: null }
  },
  props: {
    layer: {
      type: Object,
      required: true
    },
    artworkID: {
      type: String,
      required: true
    },
    offset: {
      type: Object,
      default() {
        return {
          x: 0,
          y: 0
        }
      }
    },
    scale: {
      type: Number,
      default() {
        return 1
      }
    },
    parentRatio: {
      type: Number,
      default() {
        return 1
      }
    },
    rotation: {
      type: Number,
      default() {
        return 0
      }
    },
    name_layer: {
      type: String,
      default(){
        return "";
      }
    },
  },

  data() {
    return {
      file: null,
      image: null
    }
  },

  mounted() {
    const { isPersonalized, artworkID, layer, personalized } = this
    if (isPersonalized) {
      this.file = get(personalized, `${artworkID}.${layer.id}`)
    } else {
      if (layer.hidden && layer.dependOnLayer) {
        this.file = personalized[artworkID][layer.dependOnLayer]
      } else {
        const { values } = this.layer
        const defaultValue = values.find(v => v.active) || values[0]
        this.file = defaultValue.file
      }
    }
  },

  watch: {
    personalized: {
      handler(personalized) {
        const { artworkID, layer } = this
        if (layer.hidden && layer.dependOnLayer) {
          this.file = personalized[artworkID][layer.dependOnLayer]
        }
        if (this.isPersonalized) {
          this.file = personalized[artworkID][layer.id]
        }
      },
      deep: true
    },
    file(file, oldfile) {
      const { ratio, layer, artworkID, scale } = this
      if (file) {
        const tracker = this.previewImageTracker
        const trackHandle = tracker ? tracker.begin() : null
        if (!tracker) {
          this.setImageLoadings({ key: file.key, loading: true })
        }
        var imgSrc = ''
        if (file.base64) {
          imgSrc = file.base64
        } else {
          var preset = Math.ceil(layer.width * scale)
          if (preset > 1000) {
            preset = 1000
          }
          preset = Math.ceil(preset / 50) * 50
          imgSrc = getImageURL(file.key, Math.ceil(preset), 'px', true)
        }
        const img = new window.Image(this.layer.width, this.layer.height)
        img.crossOrigin = 'Anonymous'
        img.onload = () => {
          this.image = img
          if (trackHandle) {
            trackHandle.done()
          } else {
            this.setImageLoadings({ key: file.key, loading: false })
          }
          setTimeout(() => {
            try {
              this.$refs.imgRef.getNode().cache()
              this.$refs.imgRef
                .getNode()
                .getLayer()
                .batchDraw()
            } catch (err) {}
          }, 100)
        }
        if (trackHandle) {
          img.onerror = () => trackHandle.fail(file.base64 ? 'base64 image' : imgSrc)
        }
        img.src = imgSrc
      }
    },
    customPosition(custom) {
      if (this.$refs.imgRef) {
        const { offset, parentRatio, rotation } = this
        const node = this.$refs.imgRef.getNode()
        node.setAttrs(custom)
        if (custom.absolutePosition) {
          //return
          var absolutePosition = {
            x: (custom.absolutePosition.x + offset.x) * parentRatio,
            y: (custom.absolutePosition.y + offset.y) * parentRatio
          }
          absolutePosition = getRotation(
            {
              x: absolutePosition.x,
              y: absolutePosition.y
            },
            rotation,
            {
              x: (offset.x - offset.offsetX) * parentRatio,
              y: offset.y * parentRatio
            }
          )
          node.absolutePosition(absolutePosition)
        }
        node.clearCache()
        node.getLayer().batchDraw()
        setTimeout(() => {
          try {
            this.$refs.imgRef.getNode().cache()
            this.$refs.imgRef
              .getNode()
              .getLayer()
              .batchDraw()
          } catch (err) {}
        }, 100)
      }
    }
  },

  computed: {
    ...mapGetters(['personalized']),
    isPersonalized() {
      return (
        get(this.layer, 'personalized.enable', false) &&
        !(this.layer.hidden && this.layer.dependOnLayer)
      )
    },
    customPosition() {
      const { layer, file, scale, isPersonalized } = this
      if (!isPersonalized) {
        return {}
      }
      var categoryID = get(file, 'categoryID')
      var custom = cloneDeep(get(layer, `custom.${categoryID}`, {}))
      if (custom.absolutePosition) {
        custom.absolutePosition = {
          x: custom.absolutePosition.x * scale,
          y: custom.absolutePosition.y * scale
        }
      }
      var scaleProps = [
        'x',
        'y',
        'width',
        'height',
        'cropX',
        'cropY',
        'cropHeight',
        'cropWidth'
      ]
      scaleProps.forEach(key => {
        if (custom[key]) {
          custom[key] = custom[key] * scale
        }
      })
      return omit(custom, ['cropWidth', 'cropHeight'])
    },
    configImage() {
      const { layer, scale } = this
      var filters = []
      if (Array.isArray(layer._filters)) {
        filters = layer._filters.map(filter => get(Konva.Filters, filter))
      }
      var config = {
        ...omit(layer, [
          'custom',
          'cropWidth',
          'cropHeight',
          'personalized',
          'values',
          'filters'
        ]),
        filters
      }
      var scaleProps = [
        'x',
        'y',
        'width',
        'height',
        'cropX',
        'cropY',
        'cropHeight',
        'cropWidth'
      ]
      scaleProps.forEach(key => {
        if (config[key]) {
          config[key] = config[key] * scale
        }
      })
      config.width = Math.ceil(config.width)
      config.height = Math.ceil(config.height)
      if(this.name_layer == config.id){
        config.draggable = true;
        config.name = config.id;
      }else {
        config.draggable = false;
      }
      return config
    }
  },
  methods: {
    ...mapMutations(['setImageLoadings'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PreviewArtwork/ImagePreview.vue